module.exports = __webpack_public_path__ + "img/pork.07112514.svg";